// extracted by mini-css-extract-plugin
module.exports = {"title":"c6e8ba5398--title--39crr","subtitle":"c6e8ba5398--subtitle--UTwbQ","title_wrapper":"c6e8ba5398--title_wrapper--3S3LN","single_title":"c6e8ba5398--single_title--22TGT"};